module.exports = "/wp-content/themes/conversion/public/dist//svgs/CVN-website-logo.svg";